import { render, staticRenderFns } from "./uplevel-level-stat.vue?vue&type=template&id=5d976070&scoped=true&"
import script from "./uplevel-level-stat.vue?vue&type=script&lang=js&"
export * from "./uplevel-level-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d976070",
  null
  
)

export default component.exports